<template>
  <div
    :style="{ width: width, height: height }"
    class="echartsLine"
    ref="echartsLine"
  ></div>
</template>

<script>
import * as echarts from "echarts";
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/src/utils/resize-event";
export default {
  name: "echarts-line",
  props: {
    // 宽
    width: {
      type: [Number, String],
      default: "100%",
    },
    // 高度
    height: {
      type: [Number, String],
      default: "100%",
    },
    // 数据
    series: {
      type: [Array, Object],
      default: () => [],
    },
    // 数据
    xData: {
      type: [Array, Object],
      default: () => [],
    },
    // 数据
    y1Data: {
      type: [Array, Object],
      default: () => [],
    },
    // 数据
    y2Data: {
      type: [Array, Object],
      default: () => [],
    },
    legend: {
      type: Boolean,
      default: true,
    },
    y1Name: {
      type: String,
      default: "",
    },
    y2Name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  watch: {
    xData: {
      handler() {
        this.init();
      },
      deep: true,
    },
    series: {
      handler() {
        this.init();
      },
      deep: true,
    },
    y1Data: {
      handler() {
        this.init();
      },
      deep: true,
    },
    y2Data: {
      handler() {
        this.init();
      },
      deep: true,
    },
    "$i18n.locale": {
      handler() {
        this.$nextTick(() => {
          this.init();
        });
      },
      immediate: true,
    },
  },
  methods: {
    init() {
      // const max = this._getMaxValue(this.y1Data);
      // const min = this._getMinValue(this.y1Data);
      // const max2 = this._getMaxValue(this.y2Data);
      // const min2 = this._getMinValue(this.y2Data);
      this.myChart = echarts.init(this.$refs["echartsLine"]);
      let option = {
        color: ["rgba(255, 227, 29, 1)", "rgba(104, 232, 255, 1)"],
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(9, 24, 48, 0.8)",
          borderColor: "rgba(75, 253, 238, 0.6)",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
          position: function (point, params, dom, rect, size) {
            let x = point[0];
            let y = point[1];
            let viewWidth = size.viewSize[0];
            let viewHeight = size.viewSize[1];
            let boxWidth = size.contentSize[0];
            let boxHeight = size.contentSize[1];

            if (x + boxWidth > viewWidth) {
              x = x - boxWidth;
            }
            if (y + boxHeight > viewHeight) {
              y = y - boxHeight;
            }

            return [x, y];
          },
          confine: true,
        },
        grid: {
          top: "18%",
          left: "3%",
          right: "5%",
          bottom: "3%",
          containLabel: true,
        },
        legend: {
          show: this.legend,
          right: 0,
          itemHeight: 8,
          textStyle: {
            fontSize: 14,
            color: "#fff",
          },
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,1)",
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            data: this.xData,
          },
        ],
        yAxis: [
          {
            name: this.y1Name,
            nameTextStyle: {
              color: "rgba(255,255,255,0.5)",
              padding: [0, 0, 2, 0],
            },
            type: "value",
            // min: min,
            // interval: (max - min) / 5,
            // max: max,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "rgba(255,255,255,0.5)",
              },
            },
          },
          {
            name: this.y2Name,
            nameTextStyle: {
              color: "rgba(255,255,255,0.5)",
              padding: [0, 0, 2, 0],
            },
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            // min: min2,
            // interval: (max2 - min2) / 5,
            // max: max2,
            splitLine: {
              show: false,
              lineStyle: {
                type: "dashed",
                color: "rgba(255,255,255,0.5)",
              },
            },
          },
        ],
        series:
          this.series.length > 0
            ? this.series.map((item) => ({
                ...item,
                name: item.name, // 使用传入的国际化名称
              }))
            : [
                {
                  name: this.y1Name,
                  type: "line",
                  areaStyle: {
                    normal: {
                      //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);
                      color: new echarts.graphic.LinearGradient(
                        0,
                        0,
                        0,
                        1,
                        [
                          {
                            offset: 0,
                            color: "rgba(255, 227, 29, 0.50)",
                          },
                          {
                            offset: 1,
                            color: "rgba(255, 243, 61, 0)",
                          },
                        ],
                        false
                      ),
                      shadowColor: "rgba(27, 136, 255, 0)",
                      shadowBlur: 20,
                    },
                  },
                  data: this.y1Data,
                },
                {
                  name: this.y2Name,
                  yAxisIndex: 1, //与 y2轴绑定
                  type: "line",
                  areaStyle: {
                    normal: {
                      //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);
                      color: new echarts.graphic.LinearGradient(
                        0,
                        0,
                        0,
                        1,
                        [
                          {
                            offset: 0,
                            color: "rgba(104, 232, 255, 0.5)",
                          },
                          {
                            offset: 1,
                            color: "rgba(55, 204, 253, 0)",
                          },
                        ],
                        false
                      ),
                      shadowColor: "rgba(27, 136, 255, 0)",
                      shadowBlur: 20,
                    },
                  },
                  data: this.y2Data,
                },
              ],
      };
      this.myChart.setOption(option);
      window.addEventListener("resize", () => {
        this.myChart.resize(); //当浏览器窗口大小发生变化时，图表可以进行自适应
      });
    },
    _getMaxValue(arr) {
      const max = Math.max(...arr);
      // 这样处理是为了不让最大值刚好到坐标轴最顶部
      return Math.ceil(max / 9.5) * 10;
    },

    _getMinValue(arr) {
      const min = Math.min(...arr);
      // 这样处理是为了不让最大值刚好到坐标轴最底部
      return Math.floor(min / 12) * 10;
    },
    getDom() {
      return this.$refs["echartsLine"];
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      addResizeListener(this.getDom(), this.myChart?.resize);
    });
  },
  beforeDestroy() {
    removeResizeListener(this.getDom(), this.myChart?.resize);
    this.myChart && this.myChart.dispose();
  },
};
</script>

<style scoped></style>
